import { Equipment } from './../index';

export class CompanyEquipment {
    public CompanyId: number;
    public Equipment: Equipment[] = [];
}
